module.exports = __webpack_public_path__ + "static/media/failure-med.2ca29e00.2ca29e00.svg";